import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Globe, Activity, ShieldCheck, Zap, Wifi, Cpu } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGlobalPulse() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="8565" id="the-strategic-umbrella" ref={ref} className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col items-center justify-center py-20">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--primary)_0%,transparent_40%)] opacity-10 blur-3xl" />
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/digital_grid_overlay.png')] opacity-5 bg-repeat" />
      </div>

      {}
      <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none">
        <div className="relative w-[600px] h-[600px] md:w-[800px] md:h-[800px] lg:w-[1000px] lg:h-[1000px] flex items-center justify-center">
          
          {}
          <div className="absolute inset-0 border border-primary/20 rounded-full animate-[spin_60s_linear_infinite]" />
          <div className="absolute inset-[10%] border border-primary/10 rounded-full animate-[spin_45s_linear_infinite_reverse]" />
          <div className="absolute inset-[25%] border border-dashed border-primary/30 rounded-full animate-[spin_30s_linear_infinite]" />
          
          {}
          <div className="relative w-[60%] h-[60%] rounded-full overflow-hidden shadow-[0_0_100px_var(--primary)] animate-pulse-slow">
             <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-primary/20 z-10 mix-blend-overlay" />
             <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/futuristic_earth_globe_high_res.png" alt="Strategic Network" className="w-full h-full object-cover opacity-90 animate-[spin_120s_linear_infinite] grayscale brightness-75" />
             {}
             <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/data_points_overlay.png')] opacity-40 mix-blend-screen animate-pulse" />
          </div>

          {}
          <div className={`absolute top-[15%] right-[15%] transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <Card className="w-48 bg-card/40 backdrop-blur-md border-primary/30 shadow-[0_0_30px_rgba(0,0,0,0.5)] rounded-sm">
              <CardContent className="p-3 flex items-center gap-3">
                <Activity className="w-5 h-5 text-primary animate-pulse" />
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono">ASSET GOVERNANCE</div>
                  <div className="text-xs font-bold text-primary font-mono">SECURED</div>
                </div>
              </CardContent>
            </Card>
            {}
            <div className="absolute top-full left-1/2 w-px h-20 bg-gradient-to-b from-primary/50 to-transparent -z-10" />
          </div>

          {}
          <div className={`absolute bottom-[20%] left-[10%] transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <Card className="w-56 bg-card/40 backdrop-blur-md border-primary/30 shadow-[0_0_30px_rgba(0,0,0,0.5)] rounded-sm">
              <CardContent className="p-3">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono">PORTFOLIO VALUE</span>
                  <Wifi className="w-4 h-4 text-primary" />
                </div>
                <div className="text-xl font-mono font-bold text-foreground">$1.2B+</div>
                <div className="w-full h-1 bg-muted mt-2 rounded-full overflow-hidden">
                  <div className="h-full bg-primary w-[85%] animate-[pulse_2s_infinite]" />
                </div>
              </CardContent>
            </Card>
             {}
             <div className="absolute bottom-full right-1/4 w-px h-32 bg-gradient-to-t from-primary/50 to-transparent -z-10 rotate-12 origin-bottom" />
          </div>

          {}
          <div className={`absolute top-[45%] right-[5%] transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
             <Card className="w-40 bg-card/40 backdrop-blur-md border-primary/30 shadow-[0_0_30px_rgba(0,0,0,0.5)] rounded-sm">
              <CardContent className="p-3 flex flex-col items-center text-center">
                <ShieldCheck className="w-6 h-6 text-primary mb-1" />
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono">SOVEREIGNTY</div>
                <div className="text-xs font-bold text-foreground font-mono">LEVEL 47</div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 text-center flex flex-col items-center">
        
        {}
        <h1 className={`font-default font-black text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9] mb-8 mix-blend-screen transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <span className="block bg-clip-text text-transparent bg-gradient-to-b from-secondary to-secondary/60 drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]">
            THE ARCHITECTS
          </span>
          <span className="block bg-clip-text text-transparent bg-gradient-to-b from-secondary/90 to-secondary/40 relative">
            OF DIGITAL SOVEREIGNTY
            {}
            <span className="absolute inset-0 text-primary/30 animate-pulse translate-x-[2px] mix-blend-screen" aria-hidden="true">OF DIGITAL SOVEREIGNTY</span>
            <span className="absolute inset-0 text-secondary/30 animate-pulse -translate-x-[2px] mix-blend-screen animation-delay-75" aria-hidden="true">OF DIGITAL SOVEREIGNTY</span>
          </span>
        </h1>

        {}
        <p className={`max-w-2xl text-lg md:text-xl text-muted-foreground mb-12 font-mono tracking-wide transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          Eagle 47 is the strategic umbrella unifying high-impact software ventures, digital infrastructure, and scalable intellectual property for the next era of technology.
        </p>

        {}
        <div className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <Button asChild size="lg" className="relative group bg-transparent hover:bg-primary/10 text-foreground px-10 py-8 text-lg tracking-widest overflow-hidden border-0 rounded-sm">
            <Link to="#">
              {}
              <span className="absolute inset-0 rounded-sm p-[1px] bg-gradient-to-r from-primary/50 via-primary to-primary/50 bg-[length:200%_100%] animate-[shimmer_3s_linear_infinite]">
                <span className="block w-full h-full bg-background rounded-sm" />
              </span>
              
              {}
              <span className="relative flex items-center gap-3 z-10 font-default font-bold">
                <Zap className="w-5 h-5 text-primary group-hover:text-secondary transition-colors" />
                EXPLORE PORTFOLIO
              </span>
              
              {}
              <span className="absolute inset-0 bg-primary/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </Link>
          </Button>
        </div>

        {}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50 animate-bounce">
          <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground font-mono">ASCEND TO GOVERNANCE</span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-primary to-transparent" />
        </div>

      </div>

      {}
      <div className="absolute top-10 left-10 hidden md:block">
        <Cpu className="w-8 h-8 text-primary/40 mb-2" />
        <div className="text-[10px] font-mono text-primary/40">E47.STRAT.01</div>
      </div>
      <div className="absolute bottom-10 right-10 hidden md:block text-right">
        <div className="flex gap-1 justify-end mb-2">
          <div className="w-1 h-1 bg-primary rounded-full animate-ping" />
          <div className="w-1 h-1 bg-primary rounded-full" />
          <div className="w-1 h-1 bg-primary rounded-full" />
        </div>
        <div className="text-[10px] font-mono text-primary/40">SOVEREIGN INFRASTRUCTURE SECURED</div>
      </div>

    </section>;
}